import { render, staticRenderFns } from "./AddSampleRequest.vue?vue&type=template&id=3940c34f&"
import script from "./AddSampleRequest.vue?vue&type=script&lang=js&"
export * from "./AddSampleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports